module.exports = __webpack_public_path__ + "static/solutions-hero-bottom-efaf8908ebd1bef352b6b7694491c3b0.png";